import { eventsClass } from '@/base/class/events.class'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { DateClass } from '@/base/class/date.class'
import { MobileAppClass } from '@/base/class/mobileApp.class'
import { ToolsClass } from '@/base/class/tools.class'
import { MatomoClass } from '@/base/class/matomo.class'
import { LANGUAGES_ACTIVE_LIST } from '@/base/const/lang.const'
import { PAYWALL_THEME, PAYWALL_THEME_LIST, THEME_CONTEXT_SUPPORT_LIST } from '@/base/const/paywall.const'
import { COOKIE_LANG, COOKIE_LAYOUT } from '@/base/const/cookies.const'
import { CookieClass } from '@/base/class/cookie.class'
import { getLangDirection } from '@/base/utils/lang-direction'

export default {
  head() {
    return {
      htmlAttrs: {
        lang: this.lang?.toLowerCase() || 'pl',
        dir: getLangDirection(this.lang),
      },
    }
  },
  data() {
    return {
      contextName: this.$VUE_CONTEXT_NAME,
    }
  },
  computed: {
    ...mapState({
      isPaywallView: (state) => state.payment.paywallView && !state.lang.loading,
      isPaywallThemeDark: (state) => state.payment.paywallTheme === PAYWALL_THEME.dark,
    }),
    ...mapGetters({
      lang: 'getCurrentLanguage',
    }),
  },
  methods: {
    ...mapMutations(['SET_PAYMENT_CONTEXT_NAME', 'SET_TIMER_APP_START', 'SET_PAYWALL_THEME']),
    ...mapActions(['setLanguage']),
    checkMatomoLoaded() {
      console.time('Matomo Loaded')
      if (!MatomoClass.isMatomoLoaded()) {
        setTimeout(this.checkMatomoLoaded, 100)
        return
      }
      console.timeEnd('Matomo Loaded')
    },
    setPaywallTheme(theme = PAYWALL_THEME.light) {
      if (PAYWALL_THEME_LIST.includes(theme)) {
        this.SET_PAYWALL_THEME(theme)
        CookieClass.setCookie(COOKIE_LAYOUT, theme, 1, '.autopay.eu')
      }
    },
    setInitialLanguage(initLang = null) {
      if (initLang && LANGUAGES_ACTIVE_LIST.includes(initLang)) {
        void this.setLanguage({ value: initLang.toUpperCase(), silent: true })
        return
      }
      const cookieLang = CookieClass.getCookie(COOKIE_LANG)
      if (cookieLang && LANGUAGES_ACTIVE_LIST.includes(cookieLang.toUpperCase())) {
        void this.setLanguage({ value: cookieLang.toUpperCase(), silent: true })
      }
    },
    setPageTheme(layout) {
      if (!THEME_CONTEXT_SUPPORT_LIST.includes(this.contextName)) {
        this.setPaywallTheme(PAYWALL_THEME.light)
        return
      }
      if (layout === PAYWALL_THEME.dark) {
        this.setPaywallTheme(PAYWALL_THEME.dark)
        return
      }
      if (layout === PAYWALL_THEME.light) {
        this.setPaywallTheme(PAYWALL_THEME.light)
        return
      }
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.setPaywallTheme(PAYWALL_THEME.dark)
        return
      }
      this.setPaywallTheme(PAYWALL_THEME.light)
    },
  },
  created() {
    const queryParams = ToolsClass.getQueryParams()
    this.setPageTheme(queryParams.layout)
    this.setInitialLanguage(queryParams.lang)
    this.SET_PAYMENT_CONTEXT_NAME(this.$VUE_CONTEXT_NAME)
    // if (ToolsClass.isDebugEnabled()) {
    //   this.checkMatomoLoaded()
    // }
    eventsClass.addEventsHandlers()
    if (queryParams.VersionSDK) {
      MobileAppClass.setVersionSDKParam(queryParams.VersionSDK)
    }
    if (ToolsClass.isMobileSDKMockEnabled()) {
      MobileAppClass.initMobileSDKMock()
    }
    MobileAppClass.supportExternalLinks()
    ToolsClass.disableBrowserRefresh()
  },
  mounted() {
    this.SET_TIMER_APP_START(DateClass.getCurrentTimestamp())
  },
  beforeUnmount() {
    eventsClass.removeEventsHandlers()
  },
  updated: function () {
    void this.$nextTick(function () {
      MobileAppClass.supportExternalLinks()
    })
  },
}
